import { TriggerInputDataset } from '@/hooks/api/datasets/trigger/useTriggerManualRun.ts';
import { ManualTriggerInput, ManualTriggerInputType } from '@/types/automationSteps.ts';
import FileDatasetInput from '@/pages/AutomationPage/components/ManualRunModal/components/triggerDatasetInputs/FileDatasetInput';
import TextDatasetInput from '@/pages/AutomationPage/components/ManualRunModal/components/triggerDatasetInputs/TextDatasetInput.tsx';
import FolderDatasetInput from '@/pages/AutomationPage/components/ManualRunModal/components/triggerDatasetInputs/FolderDatasetInput.tsx';
import JsonDatasetInput from '@/pages/AutomationPage/components/ManualRunModal/components/triggerDatasetInputs/JsonDatasetInput.tsx';

type props = {
  creatingRun: boolean;
  triggers: ManualTriggerInput[];
  triggerDatasets: TriggerInputDataset[];
  updateTriggerDataset: (index: number, updatedDataset: TriggerInputDataset) => void;
  automationId: string | undefined;
};

const NewRunUI = ({
  creatingRun,
  triggers,
  triggerDatasets,
  updateTriggerDataset,
  automationId,
}: props) => {
  return (
    <>
      {triggers.length === triggerDatasets.length &&
        triggers.map((t, idx) => {
          const triggerDs = triggerDatasets[idx];
          const props = {
            automationId: automationId!,
            trigger: t,
            triggerDataset: triggerDs,
            setTriggerDataset: (td: TriggerInputDataset) => updateTriggerDataset(idx, td),
            isLoading: creatingRun,
          };
          if (t.input_type === ManualTriggerInputType.File) {
            return <FileDatasetInput key={t.output_id} {...props} />;
          } else if (t.input_type === ManualTriggerInputType.Folder) {
            return <FolderDatasetInput key={t.output_id} {...props} />;
          } else if (t.input_type === ManualTriggerInputType.Text) {
            return <TextDatasetInput key={t.output_id} {...props} />;
          } else if (t.input_type === ManualTriggerInputType.Json) {
            return <JsonDatasetInput key={t.output_id} {...props} />;
          }
        })}
    </>
  );
};

export default NewRunUI;
